module.exports = __webpack_public_path__ + "img/tiktok-brands.3508cf48.svg";